const state = {
	inventoryItem: {},
};

const getters = {
	inventoryItem: (state: { inventoryItem: any }) => {
		return state.inventoryItem;
	},
};

const mutations = {
	newInventoryItem: (state: { inventoryItem: any }, payload: any) => {
		state.inventoryItem = payload;
	},
	updateInventoryItem: (state: { inventoryItem: any }, payload: any) => {
		state.inventoryItem = { ...state.inventoryItem, ...payload };
	},
};

const actions = {
	newInventoryItem: ({ commit }: any, payload: any) => {
		commit("newInventoryItem", payload);
	},
	updateInventoryItem: ({ commit }: any, payload: any) => {
		commit("updateInventoryItem", payload);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
